import React from "react";
import { Link } from "react-router-dom";
import {
	Flex,
	SectionContainer,
	SectionContent,
} from "../../styles/global.syles";
import footerlogo from "../../images/logo-footer.png";
import { DividerAndCopy, FooterContent } from "./Footer.styles";

const Footer = () => {
	return (
		<SectionContainer bg='#f1fbf2' pb='0'>
			<FooterContent>
				<Flex justify='space-between' gap='20px' className='footer-flex'>
					{/* logo  */}
					<div className='logo'>
						<img src={footerlogo} alt='logo' width='172' />
					</div>
					{/* links  */}
					<Flex justify='flex-end' gap='30px' className='info-flex'>
						<div className='info'>
							<div className='info-title'>Send Email</div>
							<div className='info-des'>beyondlottotv@gmail.com</div>
						</div>
						{/* <div className='info'>
							<div className='info-title'>Georgia</div>
							<div className='info-des'>4047345448</div>
						</div> */}
						<div className='info'>
							<div className='info-title'>Texas</div>
							<div className='info-des'>8323883526</div>
						</div>
						<div className='info'>
							<div className='info-title'>Houston</div>
							<div className='info-des'>3464981097</div>
						</div>
						<div className="info">
  <div className="info-title">
    <Link to="/privacypolicy" className="text-dark text-decoration-none">
      Privacy Policy
    </Link>
  </div>
  <div className="info-des">
    <Link to="/termsandconditions" className="text-dark text-decoration-none">
      Terms & Conditions
    </Link>
  </div>
</div>

					</Flex>
				</Flex>
			</FooterContent>
			<DividerAndCopy>
				<div className='divider'></div>
				<div className='copyright'>&copy; 2024 BeyondLottery. All rights reserved.</div>
			</DividerAndCopy>
		</SectionContainer>
	);
};

export default Footer;
